<template>
  <div>
    <el-dialog
        title="开发记录"
        :visible.sync="dialogVisible"
        width="500px"
        :before-close="close"
        :close-on-click-modal="false">
      <div>
        <!-- Tab切换 -->
        <el-tabs v-if="isShowManage" v-model="activeTab" @tab-click="handleTabClick" style="margin-bottom: 10px;">
          <el-tab-pane label="个人记录" name="personal"></el-tab-pane>
          <el-tab-pane label="管理记录" name="manage"></el-tab-pane>
        </el-tabs>
        
        <!-- 个人记录表格 -->
        <el-table v-if="activeTab === 'personal' || !isShowManage" :data="tableData" :max-height="500" stripe>
          <el-table-column fixed type="index" width="50" align="center" label="序号"></el-table-column>
          <el-table-column prop="receiveUser" label="操作人姓名" align="center"></el-table-column>
          <el-table-column prop="receiveTime" label="领取时间" align="center"></el-table-column>
          <el-table-column prop="cancelTime" label="退订时间" align="center"></el-table-column>
          <el-table-column prop="remake" label="退订备注" align="center"></el-table-column>
        </el-table>
        
        <!-- 管理记录表格 -->
        <el-table v-if="activeTab === 'manage' && isShowManage" :data="tableData" :max-height="500" stripe>
          <el-table-column fixed type="index" width="50" align="center" label="序号" :index="getManageIndex"></el-table-column>
          <el-table-column prop="receiveUser" label="操作人姓名" align="center"></el-table-column>
          <el-table-column prop="cancelTime" label="退订时间" align="center"></el-table-column>
          <el-table-column prop="remake" label="退订备注" align="center"></el-table-column>
        </el-table>
        
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
                         layout="prev, pager, next, jumper" :total="total" style="margin:auto;"></el-pagination>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import http from "api/freight";
import Util from "utils/util";

export default {
  props: {
    currRow: {
      type: Object,
      default: {}
    },
    isShowManage: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dialogVisible: true,
      tableData: [],
      manageTableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 20,
      activeTab: 'personal',
    }
  },
  mounted() {
    // 如果isShowManage为false，确保activeTab为personal
    if (!this.isShowManage) {
      this.activeTab = 'personal'
    }
    this.initDate()
  },
  methods: {
    initDate() {
      if (this.activeTab === 'manage' && this.isShowManage) {
        this.initPersonalDate(2)
      } else {
        this.initPersonalDate(1)
      }
    },
    initPersonalDate(type) {
      const params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        companyId: this.currRow.companyId,
        type
      }
      http
          .devRecordInfo(params)
          .then((e) => {
            if (e.code == 200 && e.data && e.data.dataList) {
              this.tableData = e.data.dataList.map(item=>{
                item.cancelTime = item.cancelTime != '-' ? Util.format(new Date(item.cancelTime * 1).getTime(), "yyyy-MM-dd") : '-'
                item.receiveTime = item.receiveTime != '-' ? Util.format(new Date(item.receiveTime * 1).getTime(), "yyyy-MM-dd") : '-'
                return item
              })
              this.total = e.data.total
              this.currentPage = e.data.pageNum
            } else {
              this.tableData = []
            }
          })
    },
    handleCurrentChange(index) {
      this.currentPage = index
      this.initDate()
    },
    handleTabClick(tab) {
      this.currentPage = 1
      this.total = 0
      // 清空另一个tab的数据
      if (tab.name === 'manage') {
        this.tableData = []
      } else {
        this.manageTableData = []
      }
      this.initDate()
    },
    getManageIndex(index) {
      // 序号按照退订时间倒序显示，从1开始
      return (this.currentPage - 1) * this.pageSize + index + 1
    },
    close() {
      this.$emit('closeTask', 'devLogIs')
    },
  }
}
</script>
<style lang="stylus" scoped>
.block {
  display: flex;
  padding: 5px 0;
  .center {
    margin: 10px auto;
  }
}
::v-deep .el-tabs__header {
  margin: 0;
  padding: 0 !important;
}
::v-deep .el-tabs__nav-wrap::after {
  display: none;
}
/deep/ .el-dialog__body {
  padding: 10px 20px!important;
  //border-bottom: 2px solid #EEEEEE;
}

/deep/ .el-dialog__header {
  padding: 0;
  background: rgba(52, 109, 176, 0.06);
  border-radius: 2px 2px 0px 0px;

  .el-dialog__title {
    display: block;
    line-height: 56px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    text-align: left;
    font-style: normal;
    padding-left: 30px;
  }
}
</style>
